import classNames from "classnames";
import type { FC } from "react";
import { v4 as uuid } from "uuid";
import { useFactory } from "../../helpers/reactHooks";
import styles from "./Toggle.module.scss";

type ToggleProps = {
  // accessible name, usually the title of the section the toggle switches on and off
  label: string;
  value: boolean;
  onChange?: (e: boolean) => void;
  className?: string;
};

export const Toggle: FC<ToggleProps> = ({ label, value, onChange, className }: ToggleProps) => {
  const id = useFactory(() => uuid());

  return (
    <span className={classNames(styles.toggleContainer, className)}>
      <label htmlFor={id} className={styles.toggleSwitch}>
        <input
          id={id}
          type="checkbox"
          aria-label={label}
          checked={value}
          onChange={(e) => {
            onChange?.(e.target.checked);
          }}
        />
        <span className={styles.switch} />
      </label>
    </span>
  );
};
